import { combineReducers } from '@reduxjs/toolkit';

import { highlighterApi } from '@highlight-cp/highlighter-api';
import { projectApi } from '@highlight-cp/project-api';
import { appTypeSlice, userSlice } from '@highlight-cp/redux-state';

import { appSlice } from './app/app-slice';

export const reducer = combineReducers({
  [appSlice.name]: appSlice.reducer,
  [appTypeSlice.name]: appTypeSlice.reducer,
  [highlighterApi.reducerPath]: highlighterApi.reducer,
  [userSlice.name]: userSlice.reducer,
  [projectApi.reducerPath]: projectApi.reducer,
});
